<template>
    <modal-component 
        :title="$helpers.trans('auth.profileModalTitle')" 
        :open="open" 
        @close="$emit('update:open', false)">

        <form-component 
            ref="form"
            name="Login" 
            action="/profile" 
            :append="{ id: $user.id }"
            @success="profileSaved($event)"
            :spam-filter="false">

            <div class="form-group">
                <input id="register_firstname" type="text" required class="form-control" :class="{ 'used': user.firstname }" name="firstname" v-model="user.firstname">
                <label for="register_firstname" class="form-label">
                    <span class="form-label__content">{{ $helpers.trans('auth.firstname') }}</span>
                </label>
                <div class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <input id="register_lastname" type="text" required class="form-control" :class="{ 'used': user.lastname }" name="lastname" v-model="user.lastname">
                <label for="register_lastname" class="form-label">
                    <span class="form-label__content">{{ $helpers.trans('auth.lastname') }}</span>
                </label>
                <div class="invalid-feedback"></div>
            </div>

            <div class="form-group">
                <input id="register_email" type="email" required class="form-control" :class="{ 'used': user.email }" name="email" v-model="user.email" disabled>
                <label for="register_email" class="form-label">
                    <span class="form-label__content">{{ $helpers.trans('auth.email') }}</span>
                </label>
                <div class="invalid-feedback"></div>
            </div>

            <h4 class="mt-2">{{ $helpers.trans('auth.profileChangePassword') }}</h4>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <input id="login_password" type="password" required class="form-control" :class="{ 'used': user.password }" name="password" v-model="user.password">
                        <label for="login_password" class="form-label">
                            <span class="form-label__content">{{ $helpers.trans('auth.password') }}</span>
                        </label>
                        <div class="invalid-feedback"></div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <input id="login_password_confirmation" type="password" required class="form-control" :class="{ 'used': user.password_confirmation }" name="password_confirmation" v-model="user.password_confirmation">
                        <label for="login_password_confirmation" class="form-label">
                            <span class="form-label__content">{{ $helpers.trans('auth.passwordConfirmation') }}</span>
                        </label>
                        <div class="invalid-feedback"></div>
                    </div>
                </div>
            </div>

        </form-component>
    </modal-component>
</template>
<script>
import ModalComponent from '@app/components/Modal.vue'
import FormComponent from '@app/components/Form.vue'

export default {
    components: {
        ModalComponent,
        FormComponent
    },
    props: ['open'],
    data() {
        return {
            user: {
                email: this.$user.email,
                password: null,
                password_confirmation: null,
                firstname: this.$user.firstname,
                lastname: this.$user.lastname,
            },
        }
    },

    methods: {
        profileSaved(event) {
            if(event.status == 200) {
                setTimeout(() => this.$emit('update:open', false), 500);
            }
        }
    }
}
</script>